import { render } from "./InjuryType.vue?vue&type=template&id=54bfafdc&scoped=true"
import script from "./InjuryType.vue?vue&type=script&lang=js"
export * from "./InjuryType.vue?vue&type=script&lang=js"

import "./InjuryType.vue?vue&type=style&index=0&id=54bfafdc&lang=scss&scoped=true"
import "./InjuryType.vue?vue&type=style&index=1&id=54bfafdc&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bfafdc"]])

export default __exports__